import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-trip-info',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './trip-info.component.html',
    styleUrl: './trip-info.component.scss'
})
export class TripInfoComponent {
    @Input() placement: any | null = null;
    @Input() venhicleTempeature: number | string | null = null;
    @Input() venhicleHumidity: number | string | null = null;
    @Input() stoppingTime: number | string | null = null;
    @Input() chicksTripTime: string | Date | null = null;
}
